const backendUrl = 'https://peekspeakprivate-3mr8.onrender.com';

export default backendUrl;

// const backendUrl = process.env.NODE_ENV === 'production' 
//     ? 'https://peekspeakprivate.onrender.com' 
//     : 'https://peekspeakprivate.railway.app';
// export default backendUrl;

// http://localhost:3005
